<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <Header
        ref="header"
        slot="header"
        @openEditFormDialog="openEditFormDialog"
        @batchDel="batchDel"
        @query="getData"
        :disabled="disabled"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="900px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :purchasePackageDetailCode="editFormDialogOptions.code"
        :purchasePackageCode="code"
        :disabled="editFormDialogOptions.disabled"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="closeEditFormDialog">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="save"
          >{{ $l("INDEX.btn_save") || "保存" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditForm from "./components/edit-form"
import Header from "./header.vue"
import BaseTable from "@/mixins/base-table"
import Main from "./main.vue"
export default {
  mixins: [BaseTable],
  components: { Main, Header, EditForm },
  props: {
    code: String,
    disabled: Boolean,
  },
  data() {
    return {
      loading: false,
      usePage: true,
      editFormDialogOptions: {
        disabled: false,
        visible: false,
        code: "",
      },
    }
  },
  methods: {
    getData() {
      if (!this.code) return
      this.loading = true
      this.$api
        .purchasePackageDetailListApi({
          purchasePackageCode: this.code,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    save() {
      this.$refs.editForm.save()
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit:
          this.$l("form_label_packag_detail_edit") || "编辑包装采购单明细信息",
        add:
          this.$l("form_label_packag_detail_add") || "添加包装采购单明细信息",
        detail:
          this.$l("form_label_packag_detail_detail") || "详情采购单明细信息",
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.code,
        disabled: type === "detail",
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api
            .purchasePackageDeatilBatchDelApi({
              listCode: listCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
                type: "success",
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {})
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
